/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.10.0",
  "gitBuildTime": "2026-10-05T20:50:14.263Z",
  "gitBuildVersion": "2.10.0",
  "gitCommitId": "8cb7569",
  "gitCommitIdFull": "8cb7569890ee7a1c9f759e0c50a88424ce6f29d4",
  "gitCommitTime": "2026-10-05T20:42:30.000Z",
  "version": "2.10.0-2026-10-05T20:42:30.000Z-(8cb7569)"
};
